const menus = [
  {
    icon: 'el-icon-lx-home',
    index: '/home',
    title: '系统首页',
  },
  // {
  //   icon: 'el-icon-lx-home',
  //   index: '/house',
  //   title: '户主管理',
  // },
  {
    icon: 'el-icon-user',
    index: '/userList',
    title: '用户管理',
  },
  {
    icon: 'el-icon-goods',
    index: '2',
    title: '商品管理',
    subs: [
      {
        index: '/goodsList',
        title: '商品列表',
      },
      {
        index: '/indexGoodsList',
        title: '首页商品管理',
      },
      {
        index: '/paymentDiscountGoodsList',
        title: '支付立减商品管理',
      },
      {
        index: '/cityGoods',
        title: '一县一特',
      },
      {
        index: '/goodsAuditList',
        title: '商品审核',
      },
      {
        index: '/classify',
        title: '分类列表',
      },
      {
        index: '/commentList',
        title: '评价总列表',
      },
    ],
  },
  // {
  //   icon: 'el-icon-video-camera',
  //   index: '/videoList',
  //   title: '视频管理'
  // },
   {
    icon: 'el-icon-s-order',
    index: '3',
    title: '订单管理',
    subs: [
      {
        index: '/orderList',
        title: '订单管理',
      },
      {
        index: '/settlementOrderList',
        title: '结算列表',
      },
      {
        index: '/allocateErrorRecord',
        title: '分佣执行异常记录',
      },
      {
        index: '/kuaidi100SubscribePending',
        title: '快递100订阅失败',
      },
    ]
  },
  // {
  //   icon: 'el-icon-lx-home',
  //   index: '/billList',
  //   title: '账单管理',
  // },
  {
    icon: 'el-icon-lx-copy',
    index: '7',
    title: '运营管理',
    subs: [
      {
        index: '/withdrawAuditList',
        title: '提现审核',
      },
      {
        index: '/shopSpecialRefund',
        title: '特殊关单退绿豆',
      },
      {
        index: '/activityList',
        title: '活动管理',
      },
      // {
      //   index: '/activityInfoList',
      //   title: '社区活动',
      // },
      // {
      //   index: '/informationList',
      //   title: '资讯管理',
      // },
      // {
      //   index: '/supplierList',
      //   title: '供应商管理',
      // },
      {
        index: '/shopList',
        title: '店铺管理',
      },
      {
        index: '/shopAudit',
        title: '店铺审核',
      },
      {
        index: '/shopWealthRecordList',
        title: '店铺流水',
      },
      // {
      //   index: '/shopAddressList',
      //   title: '店铺收货地址',
      // },
      // {
      //   index: '/medicineCabinetList',
      //   title: '药柜管理',
      // },
      // {
      //   index: '/investorList',
      //   title: '投资数据管理',
      // },
      // {
      //   index: '701',
      //   title: '卡包',
      //   subs:[{
      //     index: '/voucherList',
      //     title: '提货卷模版管理',
      //   },
      //   {
      //     index: '/userVoucherList',
      //     title: '用户提货卷',
      //   },]
      // },

    ],
  },
  {
    icon: 'el-icon-present',
    index: '15',
    title: '用户激励与活跃度',
    subs: [
      {
        index: '/wechatAdReward',
        title: '广告奖励配置',
      },
      {
        index: '/userCheckinConfig',
        title: '签到活跃度配置',
      },
      {
        index: '/userCheckinRecordList',
        title: '签到记录',
      },
      {
        index: '/userActivityRecordList',
        title: '活跃度流水',
      },
      {
        index: '/activityDayLeaderboard',
        title: '日活跃度排行榜',
      },
      {
        index: '/activityDailyRankRewardConfig',
        title: '日活跃度排行奖励',
      },
      {
        index: 'couponMenu',
        title: '营销优惠券',
        subs: [
          { index: '/couponTemplateManage', title: '券模板' },
          { index: '/couponUserCouponList', title: '用户券' },
          { index: '/couponGrantLogList', title: '发放记录' },
          { index: '/couponOpsCenter', title: '运营中心' },
        ],
      },
    ],
  },
  {
    icon: 'el-icon-lx-cascades',
    index: '11',
    title: '系统管理',
    subs: [
      {
        index: '/bankCodeList',
        title: '银行管理',
      },
      {
        index: '/banner',
        title: 'banner',
      },
      {
        index: '/navigation',
        title: '导航栏',
      },
      {
        index: '/indexHomeConfig',
        title: '首页配置',
      },
      {
        index: '/originStoryList',
        title: '产地故事',
      },
      {
        index: '/brochureList',
        title: '宣传页',
      },
      {
        index: '/platformManager',
        title: '后台用户管理',
      },
      {
        index: '/shopPlatformManager',
        title: '后台店铺用户管理',
      },
      {
        index: '/sysConfig',
        title: '系统设置',
      },
       {
        index: '/announcementList',
        title: '公告管理',
      },
       {
        index: '/newsList',
        title: '文章管理',
      },
       {
        index: '/invoiceTypeList',
        title: '发票类型管理',
      },
      {
       index: '/system/log',
       title: '日志管理',
     },
      // {
      //   index: '/sysConfigList',
      //   title: '系统设置列表',
      // },
      // {
      //   icon: 'el-icon-lx-cascades',
      //   index: '/channel',
      //   title: '渠道管理',
      // },

    ],
  },
  {
    icon: 'el-icon-lx-cascades',
    index: '12',
    title: '会员管理',
    subs: [
      {
        index: '/memberList',
        title: '会员管理',
      },
      {
        index: '/memberConfigList',
        title: '代理设置',
      },
      {
        index: '/partnerList',
        title: '合伙人管理',
      },
      {
        index: '/memberAddressConfigList',
        title: '区域代理设置',
      },
      {
        index: '/userMember/userMemberChangeRecord',
        title: '会员等级变更记录',
      }
    ],
  },{
    icon: 'el-icon-lx-cascades',
    index: '13',
    title: '绿豆活动管理',
    subs: [
      {
        index: '/distributionActivityList',
        title: '绿豆管理',
      },
      {
        index: '/userWealthRecordList',
        title: '用户积分记录',
      },
      {
        index: '/userPointsRecordList',
        title: '积分明细',
      },
      {
        index: '/distributionActivityRecordList',
        title: '绿豆发放记录',
      },
      {
        index: '/mungBeanAllocateBatchList',
        title: '分配充值批次',
      },
      {
        index: '/mungBeanAllocateDetailList',
        title: '分配充值明细',
      },
      {
        index: '/mungBeanAllocateSedimentList',
        title: '分配充值沉淀',
      },
      {
        index: '/specialPricePoolManage',
        title: '特价商品平台池',
      },
       {
        index: '/platformWealthRecordList',
        title: '平台pv流水',
      },

    ],
  },{
    icon: 'el-icon-lx-cascades',
    index: '14',
    title: '统计分析 ',
    subs: [
      {
        index: '/statistical/financeStatisticalIndex',
        title: '财务统计',
      },
      {
        index: '/statistical/financeSalesStatList',
        title: '财务销售明细统计',
      },
      {
        index: '/statistical/financeMungBeanStatList',
        title: '财务绿豆明细统计',
      },
    ],
  },
]

export default menus
